import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const sidebarArticles = articles.filter((a) => !a.isHot && !a.isFeatured).slice(0, 5);

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门追踪
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最热的爆料话题</p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-2/3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {hotArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  coverImage={article.coverImage}
                  categoryName={article.categoryName}
                  categorySlug={article.category}
                  author={article.author}
                  publishDate={article.publishDate}
                  readTime={article.readTime}
                  views={article.views}
                />
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="bg-background-100/60 rounded-lg p-5">
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <i className="ri-fire-line text-accent-500"></i>
                热点速递
              </h3>
              <div className="space-y-4">
                {sidebarArticles.map((article, idx) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    coverImage={article.coverImage}
                    categoryName={article.categoryName}
                    categorySlug={article.category}
                    author={article.author}
                    publishDate={article.publishDate}
                    readTime={article.readTime}
                    views={article.views}
                    variant="compact"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}